import { useAppSelector } from "../../store/reducer";
import { erVerktoyOppgaveSelector } from "../../store/selectors/selectors-oppgaveDetaljer";

import { useGetResources } from "../../hooks/useGetResources";

import styles from "../../styles/oppgave-detaljer.module.scss";

export const KontaktInformasjonComponent = (): React.JSX.Element => {
  const resources = useGetResources();
  const oppgave = useAppSelector((state) => state.oppgaveDetaljer.oppgave);
  const erVerktoyOppgave = useAppSelector(erVerktoyOppgaveSelector);

  if (erVerktoyOppgave) {
    return <></>;
  } else {
    return (
      <div className={`${styles.kontaktInformasjon} ${styles.tekstblokk}`}>
        <div>{resources?.label_kontaktheader}</div>
        {oppgave?.KontaktBeskrivelse && <div>{oppgave.KontaktBeskrivelse}</div>}
        {oppgave?.KontaktEpost && <div>{oppgave.KontaktEpost}</div>}
        {oppgave?.KontaktTelefon && <div>{oppgave.KontaktTelefon}</div>}
        {oppgave?.KontaktNavn && <div>{oppgave.KontaktNavn}</div>}
      </div>
    );
  }
};
